module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general-input d-flex flex-column"
  }, [(_vm.label) ? _c('label', {
    staticClass: "input-label mb-1",
    class: _vm.lightLabel ? 'light' : ''
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inputType == 'textarea') ? _c('textarea', {
    class: _vm.error ? 'error' : '',
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        return _vm.$emit('onChange', $event)
      }
    }
  }) : _c('input', {
    class: _vm.error ? 'error' : '',
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        return _vm.$emit('onChange', $event)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e29ee3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Input/GeneralInput.vue
// module id = 1329
// module chunks = 1